import {useDataProductForm} from "../useDataProductForm";
import React, {useEffect, useState} from "react";
import {ExtractGeneralForm} from "../extracts/ExtractGeneralForm";
import DevicesForm from "../DevicesForm";
import ZonesAssociationForm from "../../zones/ZonesAssociationForm";
import {ExtractMonitor} from "../extracts/ExtractMonitor";
import {Tabs, Yup} from "../../components";
import {Form} from "react-bootstrap";
import AudienceFilterForm from "../AudienceFilterForm";
import AggregationId from "./AggregationId";

export default function AudienceForm({audience, disabled, handleSubmit, tabProps, audiences, aggregationOptions, bucket, setSubmitButtonProps, errors}) {

  const validationSchema = Yup.object().shape({
    name: Yup.string().required(),
    start_date: Yup.string().required(),
    end_date: Yup.string().required(),
    aggregate: Yup.object().required()
  })

  const initialValues = {
    aggregate: {},
    audience_scope: {}
  }

  const {formData, setFormData, getInputProps, formProps, useParentFormRef, setDisabled} = useDataProductForm({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: handleSubmit,
    setSubmitButtonProps: setSubmitButtonProps,
    errors
  })

  useEffect(() => {
    setDisabled(disabled)
  }, [disabled])

  useEffect(() => {
    setFormData(audience)
  }, [audience])

  return (
    <>
      <Form {...formProps}/>
      <Tabs {...tabProps}>
        <ExtractGeneralForm
          formData={formData}
          getInputProps={getInputProps}
          disabled={disabled}
          bucket={bucket}
          as="audience"
          icon="stream"
          useParentFormRef={useParentFormRef}
        />
        <DevicesForm
          formData={formData}
          getInputProps={getInputProps}
          disabled={disabled}
          as="devices"
          icon="mobile"
        />
        <ZonesAssociationForm
          formData={formData}
          getInputProps={getInputProps}
          disabled={disabled}
          useParentFormRef={useParentFormRef}
          as="geography"
          icon="target"
        />
        <AggregationId
          icon="sum"
          as="aggregate"
          aggregate={formData.aggregate}
          aggregationOptions={aggregationOptions}
          dataType={formData.data_type}
          disabled={disabled}
          parentFormRef={useParentFormRef("aggregate")}
        />
        <AudienceFilterForm
          icon="audience"
          as="audience_scope"
          disabled={disabled}
          audience_scope={formData.audience_scope}
          audiences={audiences}
          parentFormRef={useParentFormRef("audience_scope")}
        />
        <ExtractMonitor
          extract={audience}
          icon="target"
          hide={!audience || audience.key === undefined}
          as="extract_monitor"
        />
      </Tabs>
    </>
  )
}
